export default __webpack_public_path__ + "static/media/CG.84c3c09b.png";